/**
 * 战区订单本机缓存
 *
 * 历史遗留: 早期只用 lastWarOrderNo 存「最近一单」(单个字符串,新单覆盖旧单),
 * 现改为 warHistoryOrders 数组保存多单, lastWarOrderNo 仅作兼容读取与「最近一单」语义保留。
 * 缓存只存订单号, 详情一律实时向后端拉取, 避免展示过期的金额/状态。
 */
const HISTORY_KEY = 'warHistoryOrders';
const LAST_KEY = 'lastWarOrderNo';
const MAX_SIZE = 20;

function readHistory() {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list.filter(Boolean) : [];
  } catch (e) {
    return [];
  }
}

function writeHistory(list) {
  try {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(0, MAX_SIZE)));
  } catch (e) {
    // 隐私模式或配额满时忽略, 不影响主流程
  }
}

/**
 * 记录一个订单号(下单成功、查询成功时调用)
 * 同时更新 lastWarOrderNo, 保持与 WarOrder.vue 既有的「最近一单」提示逻辑兼容
 */
export function addOrder(orderNo) {
  if (!orderNo) return;
  const list = readHistory().filter(no => no !== orderNo);
  list.unshift(orderNo);
  writeHistory(list);
  try {
    localStorage.setItem(LAST_KEY, orderNo);
  } catch (e) {
    // ignore
  }
}

/**
 * 列出全部缓存订单号, 新的在前。兼容只有 lastWarOrderNo 的旧数据
 */
export function listOrders() {
  const list = readHistory();
  const last = localStorage.getItem(LAST_KEY);
  if (last && !list.includes(last)) {
    list.unshift(last);
  }
  return list;
}

/**
 * 移除失效订单号(后端查不到或已退款)
 */
export function removeOrder(orderNo) {
  if (!orderNo) return;
  writeHistory(readHistory().filter(no => no !== orderNo));
  if (localStorage.getItem(LAST_KEY) === orderNo) {
    localStorage.removeItem(LAST_KEY);
  }
}
